import { BuildHtml } from "~/components/BuildHtml";
import { sidecarTagToClassNameMap } from "~/components/Sidecar/sidecarTagToClassNameMap";
import { sidecarTagToReactConverters } from "~/components/Sidecar/sidecarTagToReactConverters";
import { Tags, TagsProps } from "~/components/Tags";

export type KeyTopicsSidecarProps = {
  tags: TagsProps["tags"];
};

export const KeyTopicsSidecar: React.FC<KeyTopicsSidecarProps> = ({ tags }) => (
  <div>
    <BuildHtml
      html={`<h4>Key topics</h4>`}
      tagToReactConverters={sidecarTagToReactConverters}
      tagToClassNameMap={sidecarTagToClassNameMap}
    />
    <Tags tags={tags} />
  </div>
);
